import styled from "styled-components";
import { getPropertyByMedia } from "../helpers";
export const Button = styled.button `
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	${({ gapBottom }) => getPropertyByMedia("bottom", gapBottom)};
	${({ gapRight }) => getPropertyByMedia("right", gapRight)};
	z-index: 1;

	background-color: var(--semantic-info-weak);
	border-radius: 50%;

	width: 50px;
	height: 50px;

	color: white;
	cursor: pointer;

	svg {
		width: 28px;
		height: 28px;
	}
`;
//# sourceMappingURL=styles.js.map